import React from "react";
import { compose, withProps, withState, withHandlers } from "recompose";
import yup from "yup";
import { requestApi } from "core/api";
import * as mixpanel from "core/integrations/mixpanel";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import { createStructuredSelector } from "reselect";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { fetchApi } from "core/api/hoc";
import { insider } from "routes/paths";
import * as hoc from "modules/user/auth/hoc";
import { createErrorsSelector } from "core/helpers";
import * as api from "modules/user/onboarding/api";
import { getCountriesApi, getCitiesApi } from "modules/insiders/selectors";
import { fetchUserDataApi } from "modules/user/auth/selectors";
import { fetchUserData } from "modules/user/auth/api";
import { getCountries } from "modules/insiders/api";
import * as selectors from "modules/user/onboarding/selectors";
import View from "./View";

export default compose(
  hoc.authenticated,
  fetchApi(fetchUserData, () => ({
    selector: fetchUserDataApi,
    sync: true,
    key: "userDataApi"
  })),
  fetchApi(getCountries, () => ({
    selector: getCountriesApi,
    sync: true,
    key: "countries"
  })),
  withRouter,
  connect(
    createStructuredSelector({
      errors: createErrorsSelector(selectors.insiderOnboardingApi),
      submitApi: selectors.insiderOnboardingApi,
      cities: getCitiesApi
    }),
    dispatch => ({
      onSubmit: ({ ...values }) => {
        mixpanel.trackEvent("insiderOnboarded");
        fbPixel.fbq("trackCustom", "insiderOnboarded");
        dataLayer.push({
          event: "insiderOnboarded"
        });
        dispatch(
          api.insiderOnboarding.request({
            body: values
          })
        );
      }
    })
  ),
  withProps({
    initialValues: {
      linkedin_url: "https://linkedin.com/",
      resume: "",
      target_school: false,
      positions: [],
      availabilities: []
    },
    validationSchema: yup.object().shape({
      linkedin_url: yup.string().url("linkedIn url must be valid"),
      resume: yup.string().required("resume is required")
    })
  }),
  withProps({
    companySearchRequest: query =>
      requestApi({
        path: `/insiders/professional-info-lookup/`,
        method: "POST",
        body: {
          company_lookup: query
        }
      }),
    grouptagSearchRequest: query =>
      requestApi({
        path: `/insiders/professional-info-lookup/`,
        method: "POST",
        body: {
          group_tag_lookup: query
        }
      }),
    roleSearchRequest: query =>
      requestApi({
        path: `/insiders/professional-info-lookup/`,
        method: "POST",
        body: {
          title_lookup: query
        }
      }),
    citiesRequest: countryCode =>
      requestApi({
        path: `/insiders/cities-countries/`,
        method: "POST",
        body: {
          country_code: countryCode
        }
      })
  }),
  withState("companies", "setCompanies", []),
  withState("roles", "setRoles", []),
  withState("tags", "setGroupTags", []),
  withState("cities", "setCities", {}),
  withHandlers({
    onCountriesChange: p => async (index, country) => {
      const res = await p.citiesRequest(country.code3);

      p.setCities({
        ...p.cities,
        [index]: res.cities
      });
    },
    fetchCompanies: ({ setCompanies, companySearchRequest }) => async value => {
      const res = await companySearchRequest(value);
      setCompanies(
        res.companies.map((title, i) => ({
          id: i,
          title
        }))
      );
    },

    fetchGroupTags: ({
      setGroupTags,
      grouptagSearchRequest
    }) => async value => {
      const res = await grouptagSearchRequest(value);
      setGroupTags(
        res.group_tags.map((title, i) => ({
          id: i,
          title
        }))
      );
    },
    fetchRoles: ({ setRoles, roleSearchRequest }) => async value => {
      const res = await roleSearchRequest(value);
      setRoles(
        res.titles.map((title, i) => ({
          id: i,
          title
        }))
      );
    }
  })
)(
  ({ ...props }) =>
    !props.userDataApi.data.on_boarded ? (
      <View {...props} />
    ) : (
      <Redirect to={insider.insiderMain} />
    )
);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/ProfileSetup/Provider.js